import { Box, Typography } from '@mui/material'
import React from 'react'
import { GameINFOV2, PartnerPageData } from 'types/types'
import { useMiniLeagueStore, useParentGameStore } from '@/store/store'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Share from 'assets/icons/Share'
import ThreePeople from 'assets/icons/ThreePeople'
import Arrows from 'assets/icons/Arrows'
import { shouldHideUIForHospitality } from '@/lib/feature-flags/hospitality'
import { shouldHideUIForPOTM } from '@/lib/feature-flags/potm'

type LeagueDropdownProps = {
  pageData: PartnerPageData
  miniLeague: GameINFOV2 | null
}

function LeagueDropdown({ pageData, miniLeague }: LeagueDropdownProps) {
  const router = useRouter()
  const [selectedLeague] = useMiniLeagueStore((state) => [state.currentMiniLeague])

  const [parentGame] = useParentGameStore((state) => [state.parentGame])

  const currentMiniLeague = selectedLeague ?? miniLeague

  const shouldHideUIElements =
    shouldHideUIForHospitality(parentGame) || shouldHideUIForPOTM(parentGame)

  return (
    <Box
      mt="10px"
      display="flex"
      gap={0}
      justifyContent="space-between"
      alignItems="center"
      flexDirection="column"
    >
      <Box display="flex" flexDirection="row" justifyContent="space-between" gap={1}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexDirection="column"
          width="328px"
          sx={{
            boxShadow: 'none',
            textTransform: 'none',
          }}
        >
          <Box
            display="flex"
            width="100%"
            justifyContent={!shouldHideUIElements ? 'space-between' : 'center'}
            flexDirection="row"
          >
            {!shouldHideUIElements && (
              <>
                <Link
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '6px 16px',
                    backgroundColor: 'transparent',
                    border: '2px solid white',
                    gap: '8px',
                    justifyContent: 'space-between',
                    borderRadius: '8px',
                  }}
                  href={`/${router.query.slug}/mini-leagues/${parentGame?.id}/create`}
                >
                  <Arrows width="24px" height="24px" color="white" />
                  <Typography fontSize="14px" color="white">
                    Create
                  </Typography>
                </Link>
                <Link
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '6px 16px',
                    backgroundColor: 'transparent',
                    border: '2px solid white',
                    gap: '8px',
                    justifyContent: 'space-between',
                    borderRadius: '8px',
                  }}
                  href={{
                    pathname: `/${router.query.slug}/mini-leagues/join`,
                    query: { game_id: parentGame?.id },
                  }}
                >
                  <ThreePeople width="24px" height="24px" color="white" />
                  <Typography fontSize="14px" color="white">
                    Join
                  </Typography>
                </Link>
              </>
            )}
            <Link
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '6px 16px',
                backgroundColor: 'transparent',
                border: '2px solid white',
                gap: '8px',
                justifyContent: 'space-between',
                borderRadius: '8px',
              }}
              href={{ pathname: `/${router.query.slug}/games/${currentMiniLeague?.id}/share` }}
            >
              <Share color="white" />
              <Typography fontSize="14px" color="white">
                Share
              </Typography>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default LeagueDropdown
